<template>
  <div>
    <h2>Ordering Permissions</h2>
    <div v-if="hasMultipleProductTemplates">
      <RestrictedToggle v-model="restrictDesign">
        <template slot="allow">Allow choosing any design
          <div style="margin-left: 3em">Default design to:
            <b-form-select
              v-model="currentTemplate"
              style="max-width: 20em"
              :options="templateDefaultOptions"/>
          </div>
        </template>
        <template slot="restrict">
          Restrict design to:
          <b-form-select
            v-model="currentTemplate"
            style="margin-left: 3em; max-width: 20em"
            :options="templateOptions"/>
        </template>
      </RestrictedToggle>
    </div>
    <RestrictedToggle v-model="restrictProduct" label="changing paper"/>
    <RestrictedToggle v-model="restrictQty" label="changing qty"/>
    <!-- NB. if the wording has changed, updated ViewTeam -->
  </div>
</template>

<style lang="scss" scoped>
h2 {
  margin-top: 1em;
}
</style>

<script>
import {mapGetters, mapActions} from 'vuex';
export default {
  props: ['value'],
  computed: {
    ...mapGetters(['hasMultipleProductTemplates', 'productTemplates']),
    templateOptions() {
      return this.productTemplates.map(pt => ({value: pt.id, text: pt.name}));
    },
    templateDefaultOptions() {
      return this.templateOptions.concat({value: '*choose*', text: 'Choose during signup'})
    },
    currentTemplate: {
      get() {
        return (this.value||{}).current_producttemplate || this.productTemplates[0].id;
      },
      async set(value) {
        let settings = {...(this.value||{}), current_producttemplate: value};
        console.log('$emit input', settings)
        this.$emit('input', settings);
      }
    },
    restrictDesign: emitValueAccessor('restrictDesign'),
    restrictQty: emitValueAccessor('restrictQty'),
    restrictProduct: emitValueAccessor('restrictProduct'),
  },
}
function emitValueAccessor(field) {
  return {
    get() {
      return (this.value||{})[field];
    },
    async set(value) {
      let settings = {...(this.value||{}), [field]: value};
      this.$emit('input', settings);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/Restrictions.vue